export const parseAndAddUrlParams = (url: URL, urlParams?: string): void => {
  if (!urlParams) {
    return;
  }

  const parsedParams = new URLSearchParams(urlParams);

  for (const [key, value] of parsedParams.entries()) {
    url.searchParams.set(key, value);
  }
};
